import React, { cloneElement, isValidElement, useContext } from 'react';
import PropTypes from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Row } from '@thd-olt-component-react/grid';
import { Heading } from '@thd-olt-component-react/heading';
import { dataModel } from '../dataModel';
import { SpecificationGroupContent } from './SpecificationGroupContent';
import './specifications.scss';

export const SpecificationsDesktop = (props) => {
  const {
    itemId,
    children
  } = props;
  const { channel } = useContext(ExperienceContext);

  const { data, loading, error } = useDataModel('product', { variables: { itemId } });

  if (loading && !data) {
    return null;
  }

  if (error && !data) {
    return null;
  }

  if (!data?.product?.specificationGroup) {
    return null;
  }

  const { specificationGroup } = data.product;

  if (!specificationGroup.length) {
    return null;
  }

  return (
    <Row
      className="specifications"
      id="specifications"
      style={{ pointerEvents: 'auto' }}
    >
      <Row>
        <Heading title="Specifications" underline />
        {children && cloneElement(children, {
          itemId,
          maxfeatures: 8,
          minfeatures: 3,
          channel,
          displaySimilarLinks: true
        })}
        <SpecificationGroupContent specificationGroup={specificationGroup} />
      </Row>
    </Row>
  );
};

SpecificationsDesktop.displayName = 'SpecificationsDesktop';

SpecificationsDesktop.propTypes = {
  /** SKU Number */
  itemId: PropTypes.string.isRequired,
  /** Can take an (optional) single child component of type KeyProductFeatures */
  children: (props, propName, componentName) => {
    const prop = props[propName];
    let error;
    if (prop && (!isValidElement(prop) || prop.type.name !== 'KeyProductFeatures')) {
      error = new Error(`'${componentName}' only accepts a single child of type 'KeyProductFeatures'`);
    }
    return error;
  }
};

SpecificationsDesktop.defaultProps = {
  children: null
};

SpecificationsDesktop.dataModel = dataModel;
